import api from '@/services/api'
import { useAuthStore } from '@/store/authStore'

export interface TenantProfile {
  id: string
  tenantId: string
  valueProposition?: string | null
  targetAudience?: string | null
  localSlang?: string | null
  createdAt?: string
  updatedAt?: string
}

export interface UpsertTenantProfileData {
  valueProposition?: string
  targetAudience?: string
  localSlang?: string
}

export const tenantProfileApi = {
  async get(): Promise<TenantProfile | null> {
    const tenantId = useAuthStore.getState().tenantId
    if (!tenantId) throw new Error('Tenant not selected')

    const { data } = await api.get<TenantProfile | null>(`/api/tenants/${tenantId}/profile`)
    return data
  },

  async upsert(payload: UpsertTenantProfileData): Promise<TenantProfile> {
    const tenantId = useAuthStore.getState().tenantId
    if (!tenantId) throw new Error('Tenant not selected')

    const { data } = await api.post<TenantProfile>(`/api/tenants/${tenantId}/profile`, payload)
    return data
  },
}
